import { render, staticRenderFns } from "./HoldingsOverview.vue?vue&type=template&id=4df85c93&"
import script from "./HoldingsOverview.vue?vue&type=script&lang=js&"
export * from "./HoldingsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports